/**
 * Cloud Run function URLs for Firebase Functions
 * These functions are deployed to Cloud Run rather than the default cloudfunctions.net endpoint
 */

const PRODUCTION_URLS = {
  qrCreateCodePublic: "https://qrcreatecodepublic-2iwba32kcq-as.a.run.app",
  qrCreateCode: "https://qrcreatecode-2iwba32kcq-as.a.run.app",
  onboardingFileFinalizeBlinkbli:
    "https://onboardingfilefinalizeblinkbli-2iwba32kcq-as.a.run.app",
  qrPostMessage: "https://qrpostmessage-2iwba32kcq-as.a.run.app",
  onboardingRevalidate: "https://onboardingrevalidate-2iwba32kcq-as.a.run.app",
  createSession: "https://createsession-2iwba32kcq-as.a.run.app",
  onMemberJoined: "https://onmemberjoined-2iwba32kcq-as.a.run.app",
  updateSession: "https://updatesession-2iwba32kcq-as.a.run.app",
  qrSetUsername: "https://qrsetusername-2iwba32kcq-as.a.run.app",
  joinChat: "https://joinchat-2iwba32kcq-as.a.run.app",
  verifyCode: "https://verifycode-2iwba32kcq-as.a.run.app",
  onboardingStart: "https://onboardingstart-2iwba32kcq-as.a.run.app",
  onboardingFileFinalize:
    "https://onboardingfilefinalize-2iwba32kcq-as.a.run.app",
  onboardingStatus: "https://onboardingstatus-2iwba32kcq-as.a.run.app",
  helloWorld: "https://helloworld-2iwba32kcq-as.a.run.app",
  postMessage: "https://postmessage-2iwba32kcq-as.a.run.app",
  onboardingCancel: "https://onboardingcancel-2iwba32kcq-as.a.run.app",
  qrListJoinedRooms: "https://qrlistjoinedrooms-2iwba32kcq-as.a.run.app",
  qrJoinRoom: "https://qrjoinroom-2iwba32kcq-as.a.run.app",
  qrGetRoomMembers: "https://qrgetroommembers-2iwba32kcq-as.a.run.app",
  qrGetRoomDetails: "https://qrgetroomdetails-2iwba32kcq-as.a.run.app",
  qrAdminListRooms: "https://qradminlistrooms-2iwba32kcq-as.a.run.app",
  qrAdminDeleteRoom: "https://qradmindeleteroom-2iwba32kcq-as.a.run.app",
  qrAdminGenerateQRData:
    "https://qradmingenerateqrdata-2iwba32kcq-as.a.run.app",
} as const;

const EMULATOR_PORT = 5001;
const EMULATOR_PROJECT = "never-eat-alone-b2e0e";

/**
 * Get emulator URL for a function
 */
export function getEmulatorFunctionUrl(functionName: string): string {
  return `http://localhost:${EMULATOR_PORT}/${EMULATOR_PROJECT}/asia-southeast1/${functionName}`;
}

/**
 * Check if we're using emulator from environment
 */
const useEmulator = import.meta.env.VITE_USE_EMULATOR === "true";

/**
 * Generate function URLs based on environment
 */
export const FUNCTION_URLS = useEmulator
  ? ({
      qrCreateCodePublic: getEmulatorFunctionUrl("qrCreateCodePublic"),
      qrCreateCode: getEmulatorFunctionUrl("qrCreateCode"),
      onboardingFileFinalizeBlinkbli: getEmulatorFunctionUrl(
        "onboardingFileFinalizeBlinkbli",
      ),
      qrPostMessage: getEmulatorFunctionUrl("qrPostMessage"),
      onboardingRevalidate: getEmulatorFunctionUrl("onboardingRevalidate"),
      createSession: getEmulatorFunctionUrl("createSession"),
      onMemberJoined: getEmulatorFunctionUrl("onMemberJoined"),
      updateSession: getEmulatorFunctionUrl("updateSession"),
      qrSetUsername: getEmulatorFunctionUrl("qrSetUsername"),
      joinChat: getEmulatorFunctionUrl("joinChat"),
      verifyCode: getEmulatorFunctionUrl("verifyCode"),
      onboardingStart: getEmulatorFunctionUrl("onboardingStart"),
      onboardingFileFinalize: getEmulatorFunctionUrl("onboardingFileFinalize"),
      onboardingStatus: getEmulatorFunctionUrl("onboardingStatus"),
      helloWorld: getEmulatorFunctionUrl("helloWorld"),
      postMessage: getEmulatorFunctionUrl("postMessage"),
      onboardingCancel: getEmulatorFunctionUrl("onboardingCancel"),
      qrListJoinedRooms: getEmulatorFunctionUrl("qrListJoinedRooms"),
      qrJoinRoom: getEmulatorFunctionUrl("qrJoinRoom"),
      qrGetRoomMembers: getEmulatorFunctionUrl("qrGetRoomMembers"),
      qrGetRoomDetails: getEmulatorFunctionUrl("qrGetRoomDetails"),
      qrAdminListRooms: getEmulatorFunctionUrl("qrAdminListRooms"),
      qrAdminDeleteRoom: getEmulatorFunctionUrl("qrAdminDeleteRoom"),
      qrAdminGenerateQRData: getEmulatorFunctionUrl("qrAdminGenerateQRData"),
    } as const)
  : PRODUCTION_URLS;

export type FunctionName = keyof typeof FUNCTION_URLS;
